export interface ContextSnapshot {
  snapshotId: string
  sessionId: string
  interactionId: string
  timestamp: string
  agent: string
  modelName: string
  contextWindowSize: number
  summarizeThresholdPct: number
  sections: ContextSection[]
  messages: ContextMessage[]
  sessionContextItems: ContextItem[]
  projectContext: Record<string, string>
  systemPromptContent?: string | null
  toolDefinitions: ToolDefinitionEntry[]
  toolCalls: ToolCallDetail[]
  knowledgeRetrievals: KnowledgeRetrievalTrace[]
  totalPromptTokens: number
  totalCompletionTokens: number
  cacheReadTokens: number
  cacheWriteTokens: number
  cacheHitRatio?: number | null
  wasPruned: boolean
  wasSummarized: boolean
  summaryContent?: string | null
  estimatedTokensBeforePruning?: number | null
}

export interface ContextSection {
  key: string
  label: string
  tokens: number
  color: string
  icon: string
}

export interface ContextMessage {
  role: string
  timestamp: string
  tokens: number
  included: boolean
  kind: string
  text?: string | null
  toolName?: string | null
}

export interface ContextItem {
  kind: string
  id: string
  title: string
  tokens: number
  pinned: boolean
  metadata: Record<string, string>
}

export interface ToolDefinitionEntry {
  name: string
  tokens: number
}

export interface ToolCallDetail {
  toolCallId: string
  toolName: string
  inputSummary: string
  outputSizeBytes: number
  outputPreview?: string | null
  durationMs: number
  wasCompressed: boolean
  isKnowledgeTool: boolean
}

export interface KnowledgeRetrievalTrace {
  toolName: string
  query: string
  resultCount: number
  results: KnowledgeRetrievalResult[]
  queryTimeMs: number
}

export interface KnowledgeRetrievalResult {
  chunkId: string
  documentId: string
  title: string
  relevanceScore: number
  sourceType: string
  contentPreviewLength: number
}

export type ContextViewVariant = 'inspector' | 'flat' | 'raw'

export const SECTION_COLORS: Record<string, string> = {
  system: 'hsl(258, 58%, 40%)',
  project: 'hsl(258, 58%, 54%)',
  session: 'hsl(199, 89%, 54%)',
  tools: 'hsl(152, 60%, 44%)',
  summary: 'hsl(38, 92%, 52%)',
  messages: 'hsl(258, 58%, 74%)',
  reserve: 'hsl(240, 5%, 85%)',
}
